import React, { useState } from 'react';

import { Container } from '../../../components';
import { useAppDispatch } from '../../../store';
import { addCoordinator } from '../../../store/actions/coordinator';
import { AddCoordinatorParams } from '../../../types/coordinator';
import UserForm from '../components/user-form';
import styles from './styles';

export default function NewCoordinator() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: AddCoordinatorParams) => {
    setLoading(true);
    await dispatch(addCoordinator(data));
    setLoading(false);
  };

  return (
    <Container
      flexGrow
      spacingHorizontal="medium"
      spacingVertical="medium"
      style={styles.container}>
      <UserForm loading={loading} onSubmit={onSubmit} />
    </Container>
  );
}
